import axios from "axios";
import React, { useEffect, useState } from "react";
import { api } from "../utils/Api";
import {
	Typography,
	Flex,
	Button,
	notification,
	Statistic,
	Row,
	DatePicker,
	Col,
	Select,
} from "antd";
import Layout from "../layout/Layout";
import { CustomSpinner, CustomTable } from "../utils/CustomComponents";
import dayjs from "dayjs";
import AddMinimumInventoryModal from "./AddMinimumInventoryModal";
const { Text } = Typography;

const EXCLUDED_STATUSES = new Set([
	"Quote",
	"Waiting Inspection",
	"Wait Inspection",
	"Company cancellation",
	"Customer cancellation",
	"Trouble",
	"New Order",
]);

const MaterialSchedule = () => {
	const [loading, setLoading] = useState(false);
	const [loadingTable, setLoadingTable] = useState(false);
	const [jobList, setJobList] = useState([]);
	const [date, setDate] = useState(dayjs());
	const [plant, setPlant] = useState(
		localStorage.getItem("plant") || "61985b6a86825f39cc4aba38",
	);

	const [totalTarget, setTotalTarget] = useState(0);
	const [totalLoad, setTotalLoad] = useState(0);
	const [refresh, setRefresh] = useState(false);
	const [optionsPlant, setOptionsPlant] = useState([]);
	const [disabled, setDisabled] = useState(true);
	const [materialId, setMaterialId] = useState(null);
	const [addModalOpen, setAddModalOpen] = useState(false);

	const [apiNotification, contextHolder] = notification.useNotification();
	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	/**
	 ** Options header (columns)
	 */
	const columns = [
		{
			title: "Material",
			dataIndex: "material",
			key: "material",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "UOM",
			dataIndex: "unitOfMeasurement",
			key: "unitOfMeasurement",
			render: (value) => {
				return <Text strong>{value}</Text>;
			},
		},
		{
			title: "Material Used",
			dataIndex: "materialUsed",
			key: "materialUsed",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
					/>
				);
			},
		},
		{
			title: "Material on Hand",
			dataIndex: "materialOnHand",
			key: "materialOnHand",
			render: (value) => {
				return value ? (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
					/>
				) : (
					"-"
				);
			},
		},
		{
			title: "Requiered Per Schedule",
			dataIndex: "requiredPerSchedule",
			key: "requiredPerSchedule",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
					/>
				);
			},
		},
		{
			title: "Minimum Inventory",
			dataIndex: "minimumInventory",
			key: "minimumInventory",
			render: (value, record) => {
				return record.materialId ? (
					<Flex gap={10} align="center">
						<Statistic
							title=""
							value={value}
							precision={2}
							valueStyle={{ fontSize: 14 }}
						/>
						<Button
							type="primary"
							onClick={() => {
								setMaterialId(record.materialId);
								setAddModalOpen(true);
							}}
						>
							Change Values
						</Button>
					</Flex>
				) : (
					""
				);
			},
		},
	];

	useEffect(() => {
		getMaterials();
		getTotalTarget();
	}, [date, plant, refresh]);

	useEffect(() => {
		getPlants();
	}, []);

	const getPlants = async () => {
		const url = api + "/plant/list/57Concrete";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			let list = [];
			data.payload.map((item) => {
				if (item.name !== "Laredo")
					list.push({
						value: item._id,
						label: item.name,
					});
			});
			setOptionsPlant(list);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const getTotalTarget = async () => {
		try {
			const currentDate = `${date.year()}-${date.month() + 1}-${date.date()}`;
			const url =
				api + `/jobdateplant/57Concrete?date=${currentDate}&plant=${plant}`;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
			const { data } = await axios.get(url);
			let suma = 0;
			data.forEach((element) => {
				if (!EXCLUDED_STATUSES.has(element.jobStatus)) {
					const operandos =
						typeof element.targetYD3 === "string"
							? element.targetYD3.split("+")
							: element.targetYD3;
					suma +=
						typeof element.targetYD3 === "string"
							? parseFloat(operandos[0])
							: operandos;
				}
			});
			setTotalTarget(Math.round(suma * 100) / 100);

			const validJobs = data.filter(
				(d) =>
					d.jobStatus === "ok" ||
					d.jobStatus === "Confirm" ||
					d.jobStatus === "Operations done (AR)" ||
					d.jobStatus === "Scheduled" ||
					d.jobStatus === "Date moved" ||
					d.jobStatus === "Active" ||
					d.jobStatus === "Ready to Load" ||
					d.jobStatus === "Waiting Inspection",
			);
			const result = validJobs.reduce((acc, elJob) => acc + elJob.loadYD3, 0);
			setTotalLoad(Math.round(result * 100) / 100);
		} catch (err) {
			console.error(err.message);
		}
	};

	const getMaterials = async () => {
		try {
			setLoading(true);
			setLoadingTable(true);
			setDisabled(true);

			const currentDate = `${date.year()}-${date.month() + 1}-${date.date()}`;

			const url =
				api +
				`/job/get/materials/quantity?startDate=${currentDate}&endDate=${currentDate}&plant=${plant}`;

			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.get(url);
			if (data.success) {
				setJobList(data.payload);
				setDisabled(false);
				setLoading(false);
				setLoadingTable(false);
				// let objAR = {};
				// let objScheduled = {};
				// let listAR = [];
				// let listScheduled = [];

				// data.payload.jobsAR.map((item) => {
				// 	if (item.aggregate) {
				// 		item.aggregate.cogs.map((cog) => {
				// 			if (!objAR[`${cog.cog.material}_${cog.cog._id}`]) {
				// 				objAR[`${cog.cog.material}_${cog.cog._id}`] = {
				// 					total: cog.quantity * item.targetYD3,
				// 					unitOfMeasurement: cog.cog.unitOfMeasurement,
				// 					id: cog.cog._id,
				// 				};
				// 			} else {
				// 				objAR[`${cog.cog.material}_${cog.cog._id}`].total +=
				// 					cog.quantity * item.targetYD3;
				// 			}
				// 		});
				// 	}
				// });

				// listAR = Object.entries(objAR).map(([key, value]) => {
				// 	const keyPair = key.split("_");
				// 	return {
				// 		material: keyPair[0],
				// 		id: keyPair[1],
				// 		total: value.total / 2000,
				// 		unitOfMeasurement: value.unitOfMeasurement,
				// 	};
				// });

				// data.payload.jobsScheduled.map((item) => {
				// 	if (item.aggregate) {
				// 		item.aggregate.cogs.map((cog) => {
				// 			if (!objScheduled[`${cog.cog.material}_${cog.cog._id}`]) {
				// 				objScheduled[`${cog.cog.material}_${cog.cog._id}`] = {
				// 					total: cog.quantity * item.targetYD3,
				// 					unitOfMeasurement: cog.cog.unitOfMeasurement,
				// 					id: cog.cog._id,
				// 				};
				// 			} else {
				// 				objScheduled[`${cog.cog.material}_${cog.cog._id}`].total +=
				// 					cog.quantity * item.targetYD3;
				// 			}
				// 		});
				// 	}
				// });

				// listScheduled = Object.entries(objScheduled).map(([key, value]) => {
				// 	const keyPair = key.split("_");
				// 	return {
				// 		material: keyPair[0],
				// 		id: keyPair[1],
				// 		total: value.total / 2000,
				// 		unitOfMeasurement: value.unitOfMeasurement,
				// 	};
				// });

				// const mergedMap = {};

				// listAR.forEach((item) => {
				// 	mergedMap[item.id] = {
				// 		id: item.id,
				// 		material: item.material,
				// 		unitOfMeasurement: item.unitOfMeasurement,
				// 		materialUsed: item.total,
				// 		requiredPerSchedule: "-",
				// 	};
				// });

				// listScheduled.forEach((item) => {
				// 	if (mergedMap[item.id]) {
				// 		mergedMap[item.id].requiredPerSchedule = item.total;
				// 	} else {
				// 		mergedMap[item.id] = {
				// 			id: item.id,
				// 			material: item.material,
				// 			unitOfMeasurement: item.unitOfMeasurement,
				// 			materialUsed: "-",
				// 			requiredPerSchedule: item.total,
				// 		};
				// 	}
				// });

				// const mergedList = Object.values(mergedMap);

				// console.log(mergedList);

				// getMaterialsPlant(mergedList);
			} else {
				openNotification("error", "Error", data.message);
				setDisabled(false);
				setLoading(false);
				setLoadingTable(false);
			}
		} catch (err) {
			console.error(err.message);
			openNotification("error", "Error", err.message);
			return null;
		}
	};

	const getMaterialsPlant = async (mergedList) => {
		try {
			const start = `${date.year()}-${date.month() + 1}-${date.date()}`;
			const end = `${date.year()}-${date.month() + 1}-${date.date()}`;

			const url =
				api +
				`/materialdelivered/get/list/dates/plant?startDate=${start}&endDate=${end}&plant=${plant}`;

			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.get(url);
			if (data.success) {
				console.log(data.payload);
				// let finalList = [];
				// data.payload.map((item) => {
				// 	const index = mergedList.findIndex((i) => i.id === item.cog._id);
				// 	if (index !== -1) {
				// 		const currentObj = mergedList[index];

				// 		// const measurement = currentObj.unitOfMeasurement;
				// 		const materialUsed = currentObj.materialUsed;

				// 		// const materialMeasurement = item.measurementUnit;
				// 		const materialQuantity = item.quantity;

				// 		currentObj.materialOnHand = materialQuantity - materialUsed;
				// 		currentObj.materialId = item._id;
				// 		currentObj.minimumInventory = item.minimumInventory;

				// 		finalList.push(currentObj);
				// 	} else {
				// 		finalList.push({
				// 			id: item.cog._id,
				// 			material: item.cog.material,
				// 			unitOfMeasurement: item.cog.unitOfMeasurement,
				// 			materialUsed: "-",
				// 			requiredPerSchedule: "-",
				// 			materialOnHand: item.quantity,
				// 			materialId: item._id,
				// 			minimumInventory: item.minimumInventory,
				// 		});
				// 	}
				// });

				// setJobList(finalList);
			} else {
				openNotification("error", "Error", data.message);
			}
			setDisabled(false);
			setLoading(false);
			setLoadingTable(false);
		} catch (err) {
			console.error(err.message);
			openNotification("error", "Error", err.message);
			return null;
		}
	};

	const handleExport = () => {
		const headers = [
			"Material",
			"UOM",
			"Material Used",
			"Material on Hand",
			"Required Per Schedule",
			"Minimum Inventory",
		];
		const rows = jobList.map((item) => [
			item.material ?? "",
			item.unitOfMeasurement ?? "",
			item.materialUsed ?? "",
			item.materialOnHand ?? "",
			item.requiredPerSchedule ?? "",
			item.minimumInventory ?? "",
		]);
		const csv = [headers, ...rows]
			.map((row) =>
				row.map((cell) => `"${String(cell).replace(/"/g, '""')}"`).join(","),
			)
			.join("\n");
		const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
		const url = URL.createObjectURL(blob);
		const link = document.createElement("a");
		const dateStr = `${date.year()}-${String(date.month() + 1).padStart(2, "0")}-${String(date.date()).padStart(2, "0")}`;
		link.href = url;
		link.download = `material_schedule_${dateStr}.csv`;
		link.click();
		URL.revokeObjectURL(url);
	};

	const RenderTable = () => {
		return (
			<Flex vertical gap={12}>
				<CustomTable columns={columns} data={jobList} loading={loadingTable} />
				<Flex justify="flex-end">
					<Button type="primary" onClick={handleExport} disabled={loadingTable}>
						Export
					</Button>
				</Flex>
			</Flex>
		);
	};
	const onChangeDate = (value) => {
		setDisabled(true);
		setDate(value);
	};

	const onChangePlant = (value) => {
		setDisabled(true);
		setPlant(value);
	};

	const RenderSearch = () => (
		<Flex gap={10} align="end" justify="space-between">
			<Row gutter={16} style={{ width: "100%" }}>
				<Col span={6}>
					<DatePicker
						size="large"
						onChange={onChangeDate}
						value={date}
						allowClear={false}
						format={"MM/DD/YYYY"}
						style={{ width: "100%" }}
						disabled={disabled}
					/>
				</Col>
				<Col span={6}>
					<Select
						size="large"
						options={optionsPlant}
						value={optionsPlant.filter((o) => {
							return o.value === plant;
						})}
						onChange={onChangePlant}
						style={{ width: "100%" }}
						loading={disabled}
						disabled={disabled}
					/>
				</Col>
				<Col span={2}>
					<Statistic value={totalTarget} precision={2} />
				</Col>
				<Col span={2}>
					<Statistic value={totalLoad} precision={2} />
				</Col>
			</Row>
		</Flex>
	);

	const onCloseModal = () => {
		setAddModalOpen(false);
		setMaterialId(null);
		setRefresh((prev) => !prev);
	};

	return (
		<Layout title="Material Schedule" description="">
			<Flex vertical gap={16}>
				<Row gutter={16}>
					<Col span={6}>
						<Text style={{ fontSize: 20 }} type="secondary">
							Logistics
						</Text>
					</Col>
					<Col span={6} />
					<Col span={2}>
						<Text style={{ fontSize: 20 }} type="secondary">
							Total Target (YD3)
						</Text>
					</Col>
					<Col span={2}>
						<Text style={{ fontSize: 20 }} type="secondary">
							Total Load (YD3)
						</Text>
					</Col>
				</Row>
				<RenderSearch />
				{loading ? <CustomSpinner /> : <RenderTable />}
				{contextHolder}
				<AddMinimumInventoryModal
					addModalOpen={addModalOpen}
					materialId={materialId}
					setMaterialId={setMaterialId}
					onCloseModal={onCloseModal}
					setAddModalOpen={setAddModalOpen}
				/>
			</Flex>
		</Layout>
	);
};

export default MaterialSchedule;
